<div class="gridItemChildModule h-100" [class.hide]="!isFirstDataLoaded">
    <div class="h-100" *ngIf="!addMode && !editMode">
        <div class="search-box live-search w-75 mx-auto my-2" [hidden]="!showFilter">
            <input type="search" class="form-control tasksFilterInput" 
            autocomplete="off" 
            [(ngModel)]="filterValue" 
            [ngModelChangeDebounceTime]="400" 
            (ngModelChangeDebounced)="applyFilter()"
            placeholder="Search" 
            cvLocalizedText 
            langSection="Common" 
            langKey="Search" />
            <span class="clear-input" role="button" tabindex="0" [hidden]="!(filterValue.length > 0)" (click)="clearFilter()"></span>
        </div>
        <ul class="nav nav-tabs align-items-center border-bottom mb-3">
            <li class="nav-item">
                <a id="toDoTab" class="nav-link"[ngClass]="{'active': activeTabIndex === 0}"(click)="activeTabIndex = 0" cvLocalizedText langSection="Tasks" langKey="To_Do">To Do</a>
            </li>
            <li class="nav-item">
                <a id="sentTab" class="nav-link" [ngClass]="{'active': activeTabIndex === 1}" (click)="activeTabIndex = 1" cvLocalizedText langSection="Tasks" langKey="Sent">Sent</a>
            </li>
            <li class="nav-item">
                <a id="completedTab" class="nav-link"[ngClass]="{'active': activeTabIndex === 2}" (click)="activeTabIndex = 2"cvLocalizedText langSection="Tasks" langKey="Completed">Completed</a>
            </li>
            <li class="flex-grow-1"></li>
            <li class="mr-2">
                <button id="newTaskButton" type="button" class="btn btn-primary btn-sm" (click)="openAddMenu()" *ngIf="activeTabIndex === 0" cvLocalizedText langSection="Tasks" langKey="New">New</button>
            </li>
        </ul>
        <app-module-error id="noDataError" *ngIf="data == null" [noData]="true"></app-module-error> 
        <ag-grid-angular *ngIf="gridReady && activeTabIndex === 0" #tasksToDoGrid 
            class="flex-fill ag-theme-balham w-100" [ngClass]="showFilter ? 'grid-height-search' : 'grid-height'"
            [gridOptions]="gridOptionsToDo"></ag-grid-angular>
        <ag-grid-angular *ngIf="gridReady && activeTabIndex === 1"  #tasksSentGrid 
            class="flex-fill ag-theme-balham w-100" [ngClass]="showFilter ? 'grid-height-search' : 'grid-height'"
            [gridOptions]="gridOptionsSent"></ag-grid-angular>
        <ag-grid-angular *ngIf="gridReady && activeTabIndex === 2"  #tasksCompletedGrid 
            class="flex-fill ag-theme-balham w-100" [ngClass]="showFilter ? 'grid-height-search' : 'grid-height'" 
            [gridOptions]="gridOptionsCompleted"></ag-grid-angular>
    </div>
    <div class="h-100 pr-4" *ngIf="addMode || editMode">
        <div class="lato-bold font-size-18 pb-2 border-bottom mb-3" style="width:300px; margin-left:32px">
            <span *ngIf="addMode" cvLocalizedText langSection="Tasks" langKey="Create_New_Task">Create New Task</span>
            <span *ngIf="editMode" cvLocalizedText langSection="Tasks" langKey="Edit_Task">Edit Task</span>
        </div>
        <overlay-scrollbars style="height:calc(100% - 108px)" [options]="scrollOptions">
            <div class="pl-4 ml-2" *ngIf="addMode">
                <div class="lato-bold color-no2Pencil font-size-16 mb-3" cvLocalizedText langSection="Tasks" langKey="Assign_To">Assign To</div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" [(ngModel)]="ts.save.AssignToSelf" name="assignTo" id="{{'myTask' + moduleKey}}" [value]="true"
                        [attr.disabled]="data.AvailableLogins.length == 0 || !data.HasAssignAccess ? true : null" checked />
                    <label class="form-check-label" for="{{'myTask' + moduleKey}}" cvLocalizedText langSection="Tasks" langKey="My_Task">My Task</label>
                </div>
                <div *ngIf="data.AvailableLogins.length > 0 && data.HasAssignAccess">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" [(ngModel)]="ts.save.AssignToSelf" name="assignTo" id="{{'assignToOthers' + moduleKey}}" [value]="false" />
                        <label class="form-check-label" for="{{'assignToOthers' + moduleKey}}">
                                <cv-multi-select
                                class="multiSelectLeft"
                                [options]="data.AvailableLogins"
                                [value]="selectedLoginIDs"
                                (click)="ts.save.AssignToSelf = false"
                                (selectionChange)="onSelectionChanged($event)"
                                [placeholder]="getLocalizedString('Assign_To_Others')"
                                primaryKey="LoginID" label="LoginName"
                            ></cv-multi-select>
                        </label>
                    </div>
                </div>
                <div style="height:32px"></div>
            </div>
            <div class="pl-4 mb-3 ml-2">
                <span class="lato-bold color-no2Pencil font-size-16" cvLocalizedText langSection="Tasks" langKey="Task_Name">Task Name</span>
                <span class="color-redRyder font-size-12 ml-2" *ngIf="ts.save.Name === '' && !namePristine" cvLocalizedText langSection="Tasks" langKey="Name_Required">Name is required</span>
            </div>
            <div class="pl-4 mx-2" style="max-width:430px; margin-bottom:32px">
                <input type="text" 
                class="form-control" 
                [ngClass]="{ 'is-invalid' : ts.save.Name.length <= 0 && !namePristine }" 
                [(ngModel)]="ts.save.Name" 
                (ngModelChange)="namePristine = false"
                maxlength="50" 
                placeholder={{getLocalizedString()}}/>
            </div>
            <div class="pl-4 mb-3 ml-2">
                <span class="lato-bold font-size-16" cvLocalizedText  langSection="Tasks" langKey="Set_Date_Time">Set Date/Time</span>
                <span class="color-redRyder font-size-12 ml-2">{{dateError}}</span>
            </div>
            <div class="d-flex flex-wrap pl-4 mb-2 mx-2">
                <div class="d-flex flex-column mr-3">
                    <div class="color-no2Pencil font-size-12 mb-1" cvLocalizedText  langSection="Common" langKey="Start_Date">Start Date</div>
                    <div class="input-group">
                        <div class="search-box click-search justify-content-start">
                            <div class="input-group-append">
                                <cv-baremetrics-calendar
                                class="d-block daterange daterange--single" 
                                [(currentDate)]="ts.save.StartDate"
                                [required]="true"
                                [placeholder]="'00/00/0000'"
                                (dateChanged)="validateDates()"
                            ></cv-baremetrics-calendar>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column mr-3">
                    <div class="color-no2Pencil font-size-12 mb-1" cvLocalizedText  langSection="Common" langKey="End_Date">End Date</div>
                    <div class="input-group">
                        <div class="search-box click-search justify-content-start">
                            <div class="input-group-append">
                                <cv-baremetrics-calendar
                                class="d-block daterange daterange--single" 
                                [(currentDate)]="ts.save.DueDate"
                                [required]="false"
                                [placeholder]="'00/00/0000'"
                                (dateChanged)="validateDates()"
                            ></cv-baremetrics-calendar>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="color-no2Pencil font-size-12 mb-1" cvLocalizedText  langSection="Tasks" langKey="Time_Due">Time Due</div>
                    <div class="input-group">
                        <div class="justify-content-start">
                            <div class="input-group-append">
                                <cv-time-picker 
                                [(ngModel)]="ts.save.DueDate" 
                                [disabled]="ts.save.DueDate == null"
                                style="background-image:none"></cv-time-picker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-check pt-4" style="margin-left:32px" *ngIf="!ts.save.AssignToSelf">
                <input class="form-check-input" type="checkbox" [(ngModel)]="ts.save.Signoff" value="" id="{{'signoffCheck' + moduleKey}}" />
                <label class="form-check-label" style="margin-left:5px" for="{{'signoffCheck' + moduleKey}}" cvLocalizedText  langSection="Tasks" langKey="Allow_Signoff">Allow Assignee To Signoff Task</label>
            </div>
        </overlay-scrollbars>
        <div class="d-flex justify-content-end mt-2">
            <button type="button" class="btn btn-text mr-2" (click)="closeAddEditMenu()" cvLocalizedText  langSection="Common" langKey="Cancel_Button">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="addTask()" *ngIf="addMode"
                [attr.disabled]="ts.save.Name.length <= 0 || namePristine || dateError.length > 0 || (!ts.save.AssignToSelf && selectedLogins.length == 0) || saving ? true : null"
                cvLocalizedText langSection="Common" langKey="Create">Create</button>
            <button type="button" class="btn btn-primary" (click)="editTask()" *ngIf="editMode" [attr.disabled]="ts.save.Name.length <= 0 || namePristine || dateError.length > 0 || saving ? true : null"
                cvLocalizedText langSection="Common" langKey="Save_Button">Save</button>
        </div>
    </div>
    <div class="w-100 h-100 fixed-top bg-whaleTail" style="opacity:0.6; z-index:999" (click)="closeConfirmationDialog()" [hidden]="!confirmationDialogOpen"></div>
    <div class="tasksModulePopupWindow bg-white rounded shadow position-fixed" style="z-index:1002" [hidden]="!confirmationDialogOpen">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">
                    <span *ngIf="completeConfirm" cvLocalizedText  langSection="Tasks" langKey="Confirm_Complete">Confirm Completion</span>
                    <span *ngIf="!completeConfirm" cvLocalizedText  langSection="Tasks" langKey="Confirm_Delete">Confirm Delete</span>
                </h6>
                <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail mt-n2 mr-n2" (click)="closeConfirmationDialog()">
                    <svg class="icon-16">
                        <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                    </svg>
                </button>
            </div>
            <div class="modal-body">
                <span *ngIf="completeConfirm" cvLocalizedText  langSection="Tasks" langKey="Confirm_Complete_Text">Are you sure you want to complete this task?</span>
                <span *ngIf="!completeConfirm" cvLocalizedText  langSection="Tasks" langKey="Confirm_Delete_Text">Are you sure you want to delete this task?</span>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-text mr-2" (click)="closeConfirmationDialog()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="completeTask()" *ngIf="completeConfirm" cvLocalizedText  langSection="Tasks" langKey="Complete">Complete</button>
                <button type="button" class="btn btn-primary" (click)="deleteTask()" *ngIf="!completeConfirm" cvLocalizedText  langSection="Common" langKey="Delete">Delete</button>
            </div>
        </div>
    </div>
</div>
